import { createDateRangeFilterConfig } from '../factories/create-date-range-filter-config';
import { buildDateRangeFacetKey } from '../helpers/build-date-range-facet-key';
import { FILTER_COLOR } from './filter-colors';

export const invoiceDueDateFilterConfig = createDateRangeFilterConfig({
  facetName: buildDateRangeFacetKey({
    before: 'due_date_before',
    after: 'due_date_after',
  }),
  color: FILTER_COLOR.blue,
});
